import { z } from 'zod';

/**
 * Emojis an organizer may put on the map pin of a personal event (T-306f). Curated: activities
 * and objects only, no faces or people (no faces on the map, PRIVACY §1). Null = category icon.
 */
export const MARKER_EMOJIS = [
	'⚽',
	'🏀',
	'🎾',
	'🏐',
	'🏃',
	'🚴',
	'🧘',
	'🏊',
	'🎲',
	'🏓',
	'🎮',
	'🧩',
	'🎸',
	'🎤',
	'🎧',
	'🎬',
	'☕',
	'🍕',
	'🍷',
	'🎨',
	'📷',
	'📚',
	'🌳',
	'⛺',
	'🛶',
	'🐕',
] as const;

export type MarkerEmoji = (typeof MARKER_EMOJIS)[number];

export const markerEmojiSchema = z.enum(MARKER_EMOJIS);
